import React from 'react';
import PropTypes from 'prop-types';
import Layout from '../components/Layout';
import Template from '../views/Template/Home';

const BitcoinPage = props => {
  const {
    pageContext: { locale },
    location: { pathname },
  } = props;

  return (
    <Layout locale={locale} localeDir={pathname}>
      <Template locale={locale} template="bitcoin" />
    </Layout>
  );
};

BitcoinPage.propTypes = {
  pageContext: PropTypes.shape({
    locale: PropTypes.string,
  }).isRequired,
  location: PropTypes.shape({
    pathname: PropTypes.string,
  }).isRequired,
};

export default BitcoinPage;
